import AdcDiagram from "../../../../docs/_images/hw_ff_adc.png";
import AdcSchematics from "../../../../docs/_images/hw_ff_adc_schem.png";
import * as React from 'react';
export default {
  AdcDiagram,
  AdcSchematics,
  React
};